export default class LoginController {
    /* @ngInject */
    constructor($log, $location, $routeParams, $translate, AuthService, MomentService) {
        this.$log = $log;
        this.AuthService = AuthService;
        this.MomentService = MomentService;
        this.$location = $location;
        this.$routeParams = $routeParams;
        this.$translate = $translate;

        this.failed = undefined;
        this.loading = false;
    }

    $onInit() {
        this.AuthService.logout();
    }

    changeLanguage(langKey) {
        this.$translate.use(langKey);
        this.MomentService.moment.locale(langKey);
    }

    submit(username, password) {
        this.loading = true;
        this.AuthService.authenticate(username, password)
            .then(() => {
                // TODO: account is undefined. Not returned from authenticate..
                if (this.$routeParams.next !== undefined) {
                    this.$location.path(this.$routeParams.next);
                    this.$location.search({}); // Remove all parameters
                } else if (this.AuthService.isTransportChief()) {
                    this.$location.path('/transports');
                } else {
                    this.$location.path('/home');
                }
            })
            .catch((error) => {
                this.$log.info(`Error logging in: ${JSON.stringify(error)}`);
                this.failed = JSON.parse(error).message;
            })
            .finally(() => {
                this.loading = false;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/login-view/login-view.controller.js